import { render, staticRenderFns } from "./MmTable.vue?vue&type=template&id=0bd52b41&scoped=true"
import script from "./MmTable.vue?vue&type=script&lang=ts"
export * from "./MmTable.vue?vue&type=script&lang=ts"
import style0 from "./MmTable.vue?vue&type=style&index=0&id=0bd52b41&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bd52b41",
  null
  
)

export default component.exports